import { FC, useCallback, useContext, useMemo } from 'react';

import { RedeliveryContext } from '../redelivery-context';

const RedeliveryAnyTruckingCompany: FC = () => {
  const { truckingCompanies, setTruckingCompanies } = useContext(RedeliveryContext);

  const anyTruckingCompany = useMemo(() => !truckingCompanies?.size, [truckingCompanies?.size]);
  const setAnyTruckingCompany = useCallback(() => setTruckingCompanies(new Map()), [setTruckingCompanies]);

  return (
    <div className="text-field grid-1 h-100" style={{ minHeight: 48, minWidth: 128 }}>
      <input
        type="checkbox"
        className="align-self-center justify-self-center"
        checked={anyTruckingCompany}
        disabled={anyTruckingCompany}
        onChange={setAnyTruckingCompany}
        style={{ height: 24, width: 24 }}
      />
      <label>ANY CARRIER</label>
    </div>
  );
};

export default RedeliveryAnyTruckingCompany;
